import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { APPCONFIG } from '../../config';
import { Component, OnInit, OnDestroy } from '@angular/core';



@Component({
  selector: 'my-app-header',
  templateUrl: './header.component.html'
})
export class AppHeaderComponent implements OnInit, OnDestroy {
  
  AppConfig: any;
  Usuario: any;
  
  constructor(private router: Router) { }

  ngOnInit() {
    this.AppConfig = APPCONFIG;
    this.Usuario = JSON.parse(localStorage.getItem('currentUserCobranca'));
    if (this.Usuario != null) {
    if (this.Usuario.nome.indexOf(" ") > 0)    
      this.Usuario.primeiroNome = this.Usuario.nome.slice(0, this.Usuario.nome.indexOf(" "));
    } else {
      this.Usuario = [];
      this.Usuario.primeiroNome = "Usuário"
    }
  }

  exibirContato = () => localStorage.getItem('loginWizard') == "false"; 

  ngOnDestroy(){
  }

  selectCustomTheme(AppConfig) {
    const bgColorLight = ['11', '12', '13', '14', '15', '16', '21'].indexOf(AppConfig.colorOption) >= 0;
    const bgColorDark = AppConfig.colorOption === '31';
    const bgColorPrimary = ['22', '32'].indexOf(AppConfig.colorOption) >= 0;
    const bgColorSuccess = ['23', '33'].indexOf(AppConfig.colorOption) >= 0
    const bgColorInfo = ['24', '34'].indexOf(AppConfig.colorOption) >= 0;
    const bgColorWarning = ['25', '35'].indexOf(AppConfig.colorOption) >= 0;
    const bgColorDanger = ['26', '36'].indexOf(AppConfig.colorOption) >= 0;
    return {
      'bg-color-light': bgColorLight,
      'bg-color-dark': bgColorDark,
      'bg-color-primary': bgColorPrimary,
      'bg-color-success': bgColorSuccess,
      'bg-color-info': bgColorInfo,
      'bg-color-warning': bgColorWarning,
      'bg-color-danger': bgColorDanger
    }
  };
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/layout/header/header.component.ts